import {useEffect} from 'react';
import {eventsCustom, pushCustomEvent} from './analyticsEvents';

const useHubSpotChatLogging = (slideName: string): void => {
    useEffect(() => {
        const htmlElement = document.documentElement;

        const observer = new MutationObserver(() => {
            if (htmlElement.classList.contains('hs-messages-widget-open')) {
                pushCustomEvent(eventsCustom.openChat);
                pushCustomEvent(`openChat-${slideName || 'noName'}`);
            }
        });

        observer.observe(htmlElement, {attributes: true, attributeFilter: ['class']});

        return () => observer.disconnect();
    }, []);
};

export default useHubSpotChatLogging;
